<div class="flex flex-col gap-8">
  <div
    class="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] items-stretch gap-4 lg:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]"
  >
    @if (["Schulung", "Unterweisung"].includes(instructionType() || "")) {
      <app-dashboard-item [color]="'#916be0'">
        <ng-icon icon name="lucideTrophy"></ng-icon>
        <span>{{ progress() | percent }}</span>
        <span title>{{ "dashboard.dashboard.progress" | translate }}</span>
      </app-dashboard-item>
    }

    @if (instructionType() == "Schulung") {
      <app-dashboard-item [color]="'#3587d2'">
        <ng-icon icon name="lucideBook"></ng-icon>
        <span>{{ open() }}</span>
        <span title>{{
          "dashboard.dashboard.active-courses" | translate
        }}</span>
      </app-dashboard-item>

      <app-dashboard-item [color]="'#3aa56b'">
        <ng-icon icon name="lucideCheck"></ng-icon>
        <span>{{ confirmed() }}</span>
        <span title>{{
          "dashboard.dashboard.finished-courses" | translate
        }}</span>
      </app-dashboard-item>
    } @else if (instructionType() == "Unterweisung") {
      <app-dashboard-item [color]="'#df7023'">
        <ng-icon icon name="lucidePointer"></ng-icon>
        <span>{{ open() }}</span>
        <span title>{{
          "dashboard.dashboard.open-instructions" | translate
        }}</span>
      </app-dashboard-item>

      <app-dashboard-item [color]="'#b5e06b'">
        <ng-icon icon name="lucideCheck"></ng-icon>
        <span>{{ confirmed() }}</span>
        <span title>{{
          "dashboard.dashboard.finished-instructions" | translate
        }}</span>
      </app-dashboard-item>
    } @else if (instructionType() == "Information") {
      <app-dashboard-item [color]="'#7c78ff'">
        <ng-icon icon name="lucideInfo"></ng-icon>
        <span>{{ open() }}</span>
        <span title>{{ "dashboard.dashboard.information" | translate }}</span>
      </app-dashboard-item>
    }
  </div>

  @if (openInstructions().length > 0) {
    @if (instructionType() != "Information") {
      <h3 class="text-xl font-bold text-white">
        {{ "instruction.my-instructions.title" | translate }}
      </h3>
    }

    <div class="flex flex-col gap-4">
      @for (instruction of openInstructions(); track $index) {
        <app-instruction-item
          [instruction]="instruction.instruction"
          [instructionConfirmation]="instruction.confirmation"
          [progress]="instruction.progress"
          (open)="navigateTo($event.instruction, $event.confirmation)"
          [showProgress]="instruction.instruction.type != 'Information'"
        ></app-instruction-item>
      }
    </div>
  }

  @if (confirmedInstructions().length > 0) {
    @if (instructionType() != "Information") {
      <h3 class="text-xl font-bold text-white">
        {{ "instruction.my-confirmed-instructions.title" | translate }}
      </h3>
    }

    <div class="flex flex-col gap-4">
      @for (instruction of confirmedInstructions(); track $index) {
        <app-instruction-item
          [instruction]="instruction.instruction"
          [instructionConfirmation]="instruction.confirmation"
          [progress]="instruction.progress"
          (open)="navigateTo($event.instruction, $event.confirmation)"
          [showProgress]="instruction.instruction.type != 'Information'"
        ></app-instruction-item>
      }
    </div>
  }
</div>
